import { gql } from "@apollo/client";

export const getCustomerCardSpendFeeQuery = gql`
  query GetCustomerCardSpendFee($customerId: String!) {
    getCustomerCardSpendFee_Admin(customerId: $customerId) {
      fxSpread
    }
  }
`;

export const getOnRampFiatBankWalletFeeQuery = gql`
  query GetOnRampFiatBankWalletFee($customerId: String!) {
    getOnRampFiatBankWalletFee_Admin(customerId: $customerId) {
      fxSpread
    }
  }
`;

export const getOnRampFiatCardFeeQuery = gql`
  query GetOnRampFiatCardFee($customerId: String!) {
    getOnRampFiatCardFee_Admin(customerId: $customerId) {
      fxSpread
    }
  }
`;

export const getOffRampFiatBankWalletFeeQuery = gql`
  query GetOffRampFiatBankWalletFee($customerId: String!) {
    getOffRampFiatBankWalletFee_Admin(customerId: $customerId) {
      fxSpread
    }
  }
`;

export const setCardSpendFxOverrideMutation = gql`
  mutation SetCardSpendFxOverride($customerId: String!, $fx: Float!, $createdBy: String!) {
    setCardSpendFxOverride_Admin(customerId: $customerId, fx: $fx, createdBy: $createdBy) { fxSpread }
  }
`;

export const setOnRampFiatBankWalletFxOverrideMutation = gql`
  mutation SetOnRampFiatBankWalletFxOverride($customerId: String!, $fx: Float!, $createdBy: String!) {
    setOnRampFiatBankWalletFxOverride_Admin(customerId: $customerId, fx: $fx, createdBy: $createdBy) { fxSpread }
  }
`;

export const setOnRampFiatCardFxOverrideMutation = gql`
  mutation SetOnRampFiatCardFxOverride($customerId: String!, $fx: Float!, $createdBy: String!) {
    setOnRampFiatCardFxOverride_Admin(customerId: $customerId, fx: $fx, createdBy: $createdBy) { fxSpread }
  }
`;

export const setOffRampFiatBankWalletFxOverrideMutation = gql`
  mutation SetOffRampFiatBankWalletFxOverride($customerId: String!, $fx: Float!, $createdBy: String!) {
    setOffRampFiatBankWalletFxOverride_Admin(customerId: $customerId, fx: $fx, createdBy: $createdBy) { fxSpread }
  }
`;


